import React from "react";

export const Links = () => (
    <div
        style={{
            display: "flex",
            justifyContent: "space-evenly"
        }}
    >

        <a style={{ textAlign: "center", width: "50%" }} href="#privacy">Privacy Policy</a>
        <a style={{ textAlign: "center", width: "50%" }} href="#help">Help</a>
    </div>
);
